import { IUser, UserStatusType, WalletType } from '@/interfaces/IUser';
import { getWalletConnectProvider  } from '@/web3/getWeb3'
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AuthState } from './index';
import Web3 from 'web3';
import { getWeb3 } from '../../web3/getWeb3'

function timeout(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

type LoginReturned = IUser;

export const changeStateField = createAsyncThunk(
  'auth/changeAccountName',
  async (accountWallet: AuthState['changeStateField']) => {
    await timeout(2000);
    return accountWallet;
  }
);

export const loginUserToWebSite = createAsyncThunk(
  'auth/loginUserToWebSite',
  async (walletType: WalletType) => {
    
    const web3 = (walletType === 'walletconnect') ? await new Web3(await getWalletConnectProvider()) : await getWeb3();
    const accounts = await web3.eth.getAccounts();
    const netId = await web3.eth.net.getId();
    const authorizedUser: IUser = {
        accountName: accounts[0],
        status: UserStatusType.AUTHED,
        walletType: walletType, //TODO: duplicate usage
        networkId: netId
      };
    return { ...authorizedUser, walletType } as LoginReturned;
  }
);

export const logoutUserFromWebSite = createAsyncThunk(
  'auth/logoutUserFromWebSite',
  async () => {
    await timeout(2000);
    return {
      accountName: '',
      status: UserStatusType.VISITOR,
    } as LoginReturned;
  }
);
